"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../../../../common/components/genericInput/GenericInput");
var enquiryFormInputFieldErrorMessage_1 = require("../../service/enquiryFormInputFieldErrorMessage");
var core_1 = require("@material-ui/core");
exports.InputField = function (_a) {
    var formData = _a.formData;
    var _b, _c;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors, inputLabel = formData.options.inputLabel, placeholder = formData.placeholder, readOnly = formData.schema.readOnly, disabled = formData.disabled;
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var errorMessage = enquiryFormInputFieldErrorMessage_1.default.setErrorMessage(formData, rawErrors);
    if (!errorMessage) {
        errorMessage = currentError;
    }
    var handleChange = react_1.useCallback(function (e) {
        onChange(e.target.value);
    }, [value]);
    var checkoutLite = core_1.useTheme().checkoutLite;
    var showRequiredInPlaceholder = (_c = (_b = checkoutLite) === null || _b === void 0 ? void 0 : _b.enquiryForm) === null || _c === void 0 ? void 0 : _c.showRequiredInPlaceholder;
    return (<GenericInput_1.default label={label} required={required} id={id} value={value} currentError={errorMessage} onChange={handleChange} inputLabel={inputLabel} placeholder={placeholder} readOnly={readOnly} disabled={disabled} showRequiredInPlaceholder={showRequiredInPlaceholder}/>);
};
exports.default = exports.InputField;
